import React, { ChangeEvent, useCallback, useState } from 'react';
import { Grid } from '@material-ui/core';

import Complemento from '../Complemento';
import AcordeaoComplementos from '../AcordeaoComplementos';

import { useProdutoPizza } from '../../../../../../../hooks/produtoPizza';

import {
  ButtonAction,
  ComplementosStoredWrapper,
  DrawerTabTitle,
  HasComplementoWrapper,
  NewComplementoGrupo,
  TabWrapper,
} from '../../../drawer_styles';
import { SubmitButtonWrapper } from '../../../../styles';

interface ComplementosProps {
  grupo_id: number;
}

const Complementos: React.FC<ComplementosProps> = ({ grupo_id }) => {
  const {
    produtoPizzaData,
    resetDrawer,
    enableDisponibilidade,
    changeCurrentTabIndex,
  } = useProdutoPizza();

  const [hasComplemento, setHasComplemento] = useState(
    produtoPizzaData.complementos.length > 0 ? 'yes' : 'no',
  );
  const [btnEnabled, setBtnEnabled] = useState(
    produtoPizzaData.complementos.length > 0,
  );

  const handleRadioBtnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setHasComplemento(e.target.value);

      if (e.target.value === 'no') setBtnEnabled(false);
      else if (e.target.value === 'yes') setBtnEnabled(true);
    },
    [],
  );

  const handleSubmit = useCallback(() => {
    enableDisponibilidade();
    changeCurrentTabIndex(3);
  }, [enableDisponibilidade, changeCurrentTabIndex]);

  return (
    <TabWrapper>
      <DrawerTabTitle>
        <h1>Complementos</h1>
        <span>Seu produto tem algum complemento? Adicione aqui :&#41;</span>
      </DrawerTabTitle>

      <div>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <HasComplementoWrapper>
              <div>
                <span>Selecione uma opção:</span>

                <form>
                  <label htmlFor="no_have">
                    <input
                      checked={hasComplemento === 'no'}
                      type="radio"
                      id="no_have"
                      name="has_complemento"
                      value="no"
                      onChange={handleRadioBtnChange}
                    />
                    Não, este produto não tem complemento
                  </label>

                  <label htmlFor="have">
                    <input
                      checked={hasComplemento === 'yes'}
                      type="radio"
                      id="have"
                      name="has_complemento"
                      value="yes"
                      onChange={handleRadioBtnChange}
                    />
                    Sim, este produto tem complemento
                  </label>
                </form>
              </div>
            </HasComplementoWrapper>
          </Grid>

          <Grid item xs={12}>
            <Complemento isEnabled={btnEnabled} grupo_id={grupo_id} />
          </Grid>
          {produtoPizzaData.complementos.length > 0 &&
            hasComplemento === 'yes' && (
              <Grid item xs={12}>
                <ComplementosStoredWrapper>
                  <h2>Grupos de complementos que compõem esse produto</h2>
                </ComplementosStoredWrapper>

                <AcordeaoComplementos />
              </Grid>
            )}
          <Grid item xs={12}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={resetDrawer}
              >
                Cancelar
              </ButtonAction>

              <ButtonAction
                type="button"
                className="submit"
                onClick={handleSubmit}
              >
                Continuar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </div>
    </TabWrapper>
  );
};

export default Complementos;
